declare global {
  interface Window {
    __API__?: {
      VITE_API_BASE_URL: string;
      VITE_API_TIMEOUT?: string;
    };

    __APP__?: {
      VITE_ALLOWED_HOSTS: string;
      // Optional: absent in every environment that has not switched the
      // Microsoft provider on. Read through `microsoftSsoEnabled()`, which
      // treats anything but an explicit opt-in as off.
      MICROSOFT_SSO?: string;
      VITE_CLIENT_PORTAL_URL?: string;
      VITE_ADVISOR_URL?: string;
    };

    __FIREBASE__?: {
      API_KEY: string;
      AUTH_DOMAIN: string;
      PROJECT_ID: string;
    };

    // Calendar OAuth client ids. Public by nature — they ship in config.js so
    // the browser can start the consent flow — and both optional, because an
    // environment with no id configured is a supported state that the UI
    // reports as "not set up" rather than a broken button.
    __CALENDAR__?: {
      GOOGLE_CLIENT_ID?: string;
      MICROSOFT_CLIENT_ID?: string;
    };
  }
}

const apiEnv = window.__API__;
const appEnv = window.__APP__;
const firebaseEnv = window.__FIREBASE__;

export const config = {
  app: {
    basePath: import.meta.env.BASE_URL,
    clientPortalUrl: appEnv?.VITE_CLIENT_PORTAL_URL ?? '',
    advisorUrl: appEnv?.VITE_ADVISOR_URL ?? '',
    allowedHosts: appEnv?.VITE_ALLOWED_HOSTS
      ? appEnv.VITE_ALLOWED_HOSTS.split(',')
      : [],
  },
  api: {
    baseUrl: apiEnv?.VITE_API_BASE_URL,
    timeout: apiEnv?.VITE_API_TIMEOUT
      ? Number(apiEnv.VITE_API_TIMEOUT)
      : undefined,
  },
  firebase: {
    apiKey: firebaseEnv?.API_KEY ?? '',
    authDomain: firebaseEnv?.AUTH_DOMAIN ?? '',
    projectId: firebaseEnv?.PROJECT_ID ?? '',
  },
};
